import Link from '@/components/Link/Link';
import { useInvoice } from '@/hooks/invoice/useInvoice';
import { useConfig } from '@/hooks/useConfig';
import ErrorIcon from '@mui/icons-material/Error';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const PayError = () => {
  const { queryError } = useInvoice();
  const { t } = useTranslation();
  const { urls } = useConfig();
  const [, setSearchParams] = useSearchParams();

  useEffect(() => setSearchParams({}), []);

  return (
    <Stack gap={4} alignItems='center' justifyContent='center'>
      <Typography component='h1' variant='h2' fontWeight='bold'>
        {queryError?.status === 404 ? t('page.pay.error.reference-not-found') : t('page.pay.error.generic-error')}
      </Typography>

      <ErrorIcon color='error' fontSize='large' />

      <Typography align='center' variant='body2'>
        {t('page.pay.error.try-again-or-change-payment')}{' '}
        <Link href='/pay' color='inherit'>
          {t('common-phrases.click-here')}
        </Link>
      </Typography>

      <Typography align='center' variant='body2'>
        {t('page.pay.error.on')}{' '}
        <Link href={urls.myPages} target='_blank' color='inherit'>
          {t('common-phrases.my-pages')}
        </Link>{' '}
        {t('page.pay.error.click-here-to-view-orders')}
      </Typography>
    </Stack>
  );
};

export default PayError;
